import { useState, useEffect} from "react";
import { getPostponedtrips, fetchDest, fetchleadcallbydate, fetchtripcallbydate, todaysignin, searchLeadsbyDate, searchconvTripsbyStartDate, fetchTripsbyNumber, fetchcustbydob, url as serverurl, fetchRules, fetchLeads7to90, fetchtripbycreateddate, getallPostponedtrips, fetchQuotebyId, searchconvTripsbyDate, fetchEmployees, ggwacampaign, fetchdupTripsbyNumber} from "../api/customerapi";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@mui/x-data-grid";
import { Dialog } from "@mui/material";
import {CSVLink} from "react-csv"
import GetRole from "./user";
import { getquality, newgetqualitylead, total, removeDuplicatesmulti, sslist, checkDate, DateCalc2, getSumByKey, getempTL, getmanager} from "./date";
import DateCalc from "./date";
import {
    Paper,
    FormControl,
    Button,
    TextField,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Table,
    TableCell,
    TableRow
  } from "@material-ui/core";


  //const socket = io(serverurl);
  const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2),
      width: theme.spacing(30),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: "left",
    },
    headertext: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(3),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(24),
      height: theme.spacing(5),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      fontSize: 14,
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(24),
      height: theme.spacing(5),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      fontSize: 14,
    },
  })); 
const Salessupport = () => {
    const classes = useStyles();
    const width = window.innerWidth - 200;
   // var {cuser, role}=GetRole();
   //const { appData, loading } = useAppData();
    const lcolumns2 = [
        {
          field: "lead_id",
          headerName: " Lead ID",
          width: width / 12*0.75,
          cellClassName: "gridcell",
          //align:"center",
          //headerAlign:"center"
        },
        {
          field: "lead_name",
          headerName: "lead Name",
          width: (width / 12) * 1.5,
        },
        
        {
          field: "lead_status",
          headerName: "Quality",
          width: (width / 12)*0.75,
        },
        {
          field: "lead_destination",
          headerName: "Destination",
          width: (width / 12)*0.75,
        },
       
        {
          field: "lead_createdAt",
          headerName: "Created At",
          width: (width / 12) * 1,
        },
        
       
        {
          field: "dup_number",
          headerName: "Dup",
          width: width / 12*2,
        },
        {
          field: "support",
          headerName: "Support",
          width: width / 12,
        },
       
        {
            field: "attempt1",
            headerName: "Attempt 1",
            width: width / 12*2,
          },
          {
            field: "attempt2",
            headerName: "Attempt 2",
            width: width / 12*2,
          },
          {
            field: "attempt3",
            headerName: "Attempt 3",
            width: width / 12*2,
          },
         
          
           {
            field: "notes",
            headerName: "Notes",
            width: width / 12*2,
          },
           {
          field: "lead_travel_date",
          headerName: "Travel Date",
          width: (width / 12),
          },
          {
          field: "phone",
          headerName: "Contact",
          width: (width / 12)*0.75,
        },
         {
          field: "work_done_time",
          headerName: "Work Done?",
          width: width / 12,
        },
        {
          field: "time_to_action",
          headerName: "TTA",
          width: (width / 12),
        },
        
        
      ];

    const lcolumns18 = [
        {
          field: "lead_id",
          headerName: " Lead ID",
          width: width / 12*0.75,
          cellClassName: "gridcell",
          //align:"center",
          //headerAlign:"center"
        },
        {
          field: "lead_name",
          headerName: "lead Name",
          width: (width / 12) * 1.5,
        },
         {
          field: "lead_travel_date",
          headerName: "Travel Date",
          width: (width / 12),
          },
        
        {
          field: "lead_status",
          headerName: "Quality",
          width: (width / 12)*0.75,
        },
        {
          field: "lead_destination",
          headerName: "Destination",
          width: (width / 12)*0.75,
        },
       
        {
          field: "lead_createdAt",
          headerName: "Created At",
          width: (width / 12) * 1,
        },
         {
          field: "work_complete",
          headerName: "Work Done",
          width: (width / 12)*0.75,
        },
       
        {
            field: "attempt1",
            headerName: "Attempt 1",
            width: width / 12*2,
          },
          {
            field: "attempt2",
            headerName: "Attempt 2",
            width: width / 12*2,
          },
          {
            field: "attempt3",
            headerName: "Attempt 3",
            width: width / 12*2,
          },
          {
            field: "attempt4",
            headerName: "Attempt 4",
            width: width / 12*2,
          },       
      ];
    const lcolumns5 = [
        {
          field: "lead_id",
          headerName: " Lead ID",
          width: width / 12*0.75,
          cellClassName: "gridcell",
          //align:"center",
          //headerAlign:"center"
        },
        {
          field: "lead_name",
          headerName: "lead Name",
          width: (width / 12) * 1.5,
        },
         {
          field: "lead_owner",
          headerName: "lead Owner",
          width: (width / 12) * 1,
        },
        
        {
          field: "lead_status",
          headerName: "Quality",
          width: (width / 12)*0.75,
        },
        {
          field: "lead_destination",
          headerName: "Destination",
          width: (width / 12)*0.75,
        },   
        {
          field: "fr_wa",
          headerName: "WA Sent?",
          width: (width / 12)*0.75,
        },   
        {
            field: "attempt1",
            headerName: "Attempt 1",
            width: width / 12*2,
          },
          {
            field: "attempt2",
            headerName: "Attempt 2",
            width: width / 12*2,
          },
          {
            field: "attempt3",
            headerName: "Attempt 3",
            width: width / 12*2,
          },
        
      ];
    const tcolumns=[
      {
        field: "trip_id",
        headerName: " Trip Id",
        width: width / 12*0.75,
        cellClassName: "gridcell",
        //align:"center",
        //headerAlign:"center"
      },
      {
        field: "cust_name",
        headerName: "Name",
        width: (width / 12) * 1.75,
      },
      {
        field: "trip_owner",
        headerName: "Owner",
        width: (width / 12)*1.75,
      },
      {
        field: "dest",
        headerName: "Destination",
        width: (width / 12),
      },
      {
        field: "trip_status",
        headerName: "Status",
        width: (width / 12),
      },
      {
        field: "postponedAt",
        headerName: "Postponed At",
        width: (width / 12)*2,
      },
      {
        field: "last_fup",
        headerName: "Last FUP",
        width: (width / 12)*2,
      },
    ]
  const tcolumns2=[
      {
        field: "trip_id",
        headerName: " Trip Id",
        width: width / 12*0.75,
        cellClassName: "gridcell",
        //align:"center",
        //headerAlign:"center"
      },
      {
        field: "cust_name",
        headerName: "Cust Name",
        width: (width / 12),
      },
      
      {
        field: "trip_owner",
        headerName: "Owner",
        width: (width / 12)*1.75,
      },
      {
        field: "dest",
        headerName: "Destination",
        width: (width / 12),
      },
      {
        field: "trip_status",
        headerName: "Status",
        width: (width / 12),
      },
      {
        field: "lead_id",
        headerName: "Lead Id",
        width: (width / 12),
      },
      {
        field: "initial_quality",
        headerName: "Initial Quality",
        width: (width / 12),
      },
      
    ]
    const lcolumns = [
      {
        field: "lead_id",
        headerName: " Lead ID",
        width: width / 12*0.75,
        cellClassName: "gridcell",
        //align:"center",
        //headerAlign:"center"
      },
      {
        field: "lead_name",
        headerName: "lead Name",
        width: (width / 12) * 1.75,
      },
      {
        field: "phone",
        headerName: "Contact",
        width: (width / 12)*0.75,
      },
      {
        field: "lead_status",
        headerName: "Quality",
        width: (width / 12)*0.75,
      },
      {
        field: "lead_destination",
        headerName: "Destination",
        width: (width / 12)*0.75,
      },
     
      {
        field: "time_to_action",
        headerName: "TTA",
        width: (width / 12),
      },
      {
        field: "dup_number",
        headerName: "Dup",
        width: width / 12,
      },
      {
        field: "support",
        headerName: "Support",
        width: width / 12,
      },
      {
        field: "model",
        headerName: "Model",
        width: width / 12,
      },
      
      {
          field: "attempt1",
          headerName: "Attempt 1",
          width: width / 12*2,
        },
        {
          field: "attempt2",
          headerName: "Attempt 2",
          width: width / 12*2,
        },
        {
          field: "attempt3",
          headerName: "Attempt 3",
          width: width / 12*2,
        },
      
      
    ];

    const columns10 = [
     {
      field: "call_to_number",
      headerName: "Cust Number",
      width: width / 12*2,
    },
    {
      field: "talk_time",
      headerName: "Talk Time",
      width: width / 12,
    },
    {
      field: "fr_wa",
      headerName: "FR WA",
      width: width / 12,
    },
    {
      field: "effective",
      headerName: "Effective",
      width: width / 12*2,
    },
    {
      field: "disconnected_by",
      headerName: "Disconnected By",
      width: width / 12*2,
    },
   {
      field: "agent_name",
      headerName: "Agent",
      width: width / 12*2,
    },
    {
      field: "object_type",
      headerName: "Type",
      width: width / 12,
    },
      {
      field: "object_id",
      headerName: "ID",
      width: width / 12,
    },
    {
      field: "createdAt",
      headerName: "CreatedAt",
      width: width / 12*2,
    },
    {
      field: "call_start",
      headerName: "Call Time",
      width: width / 12*2,
    },
    {
      field: "uuid",
      headerName: "UUID",
      width: width / 12*2,
    },
    {
      field: "call_id",
      headerName: "Call Id",
      width: width / 12*2,
    },
     {
      field: "call_from_number",
      headerName: "Caller",
      width: width / 12*2,
    },
     {
      field: "record",
      headerName: "Recording URL",
      width: width / 12*2,
    },
    {
      field: "call_connected",
      headerName: "Connected",
      width: width / 12,
    },
    {
      field: "gap",
      headerName: "Gap",
      width: width / 12,
    },
   
  ];
  const headers10=[
        {label:"Cust Number", key:"call_to_number"},
        {label:"Talk Time", key:"talk_time"},
        {label:"Effective", key:"effective"},
        {label:"FR WA", key:"fr_wa"},
        {label:"Disconnected By", key:"disconnected_by"},
        {label:"Agent", key:"agent_name"},
        {label:"Type", key:"object_type"},
        {label:"ID", key:"object_id"},
        {label:"CreatedAt", key:"createdAt"},
        {label:"Call Time", key:"call_start"},
        {label:"UUID", key:"uuid"},
        {label:"Call Id", key:"call_id"},
        {label:"Caller", key:"call_from_number"},
        {label:"Connected", key:"call_connected"},
        {label:"Record", key:"record"},
        {label:"Gap", key:"gap"},
    ]
    const [searchData6, setsearchData6] = useState([{}]);
    const [searchData4, setsearchData4] = useState([{}]);
    const [searchData5, setsearchData5] = useState([{}]);
      var [leadfilterData, setleadfilterData] = useState({});
      var [leadfilterData2, setleadfilterData2] = useState({});
      var [dupData, setdupData] = useState({});
      var [postponedtrips, setpostponedtrips] = useState([]);
      var [listtripdata, setlisttripdata] = useState([]);
      const [listleadData4, setlistleadData4] = useState([{}]);
      const [listleadData3, setlistleadData3] = useState([{}]);
      const [listleadData5, setlistleadData5] = useState([{}]);
      const [listleadData18, setlistleadData18] = useState([{}]);
      const [splist, setsplist] = useState([]);
      const [splist2, setsplist2] = useState([]);
      const [emp, setemp] = useState([]);
      const [emp2, setemp2] = useState([]);
      const [dest, setdest] = useState([]);
      const [secondsPassed, setSecondsPassed] = useState(0);
      const [open, setopen] = useState(0);
       const [showallpostponed, setshowallpostponed] = useState(0);
      const [calldataleads2, setcalldataleads2] = useState([]);
      const { cuser, role, employeelist, destinationlist, loading } = GetRole();
      const gridcellclicklead = (id) => {
        window.open("/lead/" + id, "_blank");
        //console.log("/custdataentry/"+id);
      };

      const gridcellclick = (id) => {
        window.open("/tripdataentry/" + id, "_blank");
        //console.log("/custdataentry/"+id);
      };

      useEffect(() => {
        
          if (!loading) {
       handleleadSearch7(DateCalc(-3),DateCalc(1))
       getEmployees();
        getDest();
       
          }
        //getPostponed()
       //handleleadSearch()
        // socket.on("newLead", (data) => {
        //   console.log("Notification received:", data);
        // });
        // const interval = setInterval(() => {
        //   setSecondsPassed(prev => prev + 1);
        // }, 1000);
    
        // // return () => 
        //   return () => {
        //     clearInterval(interval);
        //     //socket.off("newLead");
        //   }



        
      }, [loading, cuser, role, employeelist, destinationlist]);

      // useEffect(() => {
      //   socket.on("newLead", (data) => {
      //     console.log("Notification received:", data);
      //   });
      
      //   return () => {
      //     socket.off("newLead");
      //   };
      // }, []);
       const handlecallSearch2=async (e) =>{
          let sd=new Date(DateCalc2(searchData4.start_date, -1))
          let ed=new Date(DateCalc2(searchData4.end_date, -1))
          const data=await fetchtripcallbydate(sd, ed)
          const data2=await fetchleadcallbydate(sd, ed)
          console.log(data.data)
          console.log(data2.data)
          var temp=[], temp2=[]
          for(let i=0;i<data.data.length;i++){
            var tempobj={
              callrecord:data.data[i].callrecord,
              object_type:"Trip",
              object_id:data.data[i].trip_id,
              fast_reach:"",
              createdAt:data.data[i].createdAt,
              fr_wa:"",
            }
            temp=[...temp, tempobj]
          }
           for(let i=0;i<data2.data.length;i++){
            var tempobj2={
              callrecord:data2.data[i].callrecord,
              object_type:"Lead",
              fr_wa:data2.data[i].fast_reach_whatsapp,
              object_id:data2.data[i].lead_id,
              fast_reach:data2.data[i].manual_fast_reach_attempted,
              createdAt:data2.data[i].createdAt
            }
            if(i==2){
              console.log(tempobj2)
              console.log(temp2)
            }
            temp2=[...temp2, tempobj2]
          }
          // var temp=data2.data.map(l=>l.callrecord)
          // var temp2=data.data.map(l=>l.callrecord)
          console.log(temp)
          console.log(temp2)
          console.log([...temp,...temp2])
          setcalldataleads2([...temp,...temp2])
        
          
        }

      const getEmployees = async () => {
        //const data = await fetchEmployees();
        //const custdatalistfromdb= data.data
    
        const empsplist = employeelist.filter((emp) => emp.role == "Sales Support");
        const empshortname = empsplist.map((emp) => emp.short_name);
        let sortedemp = empshortname.sort()
        setemp(sortedemp);
    
        const empsplist2 = employeelist.filter((emp) => emp.role == "Sales" || emp.role=="TL"|| emp.role == "SME");
        const empshortname2 = empsplist2.map((emp) => emp.short_name);
        let sortedemp2 = empshortname2.sort()
        setemp2(sortedemp2);
      };
    
      const getDest = async () => {
        try{
        //const data = await fetchDest();
        //const temp=destinationlist.filter(d=>"order" in d)
        setdest(destinationlist);
      }catch(err){
        console.log(err)
      }
      }

     

      const handleleadSearch=async () => {
        const data = await searchLeadsbyDate(
          DateCalc(-1),
          DateCalc(1)
        );
        const temp=data.data.filter(l=>checkDate(l.createdAt) && !(l.lead_campaign=="" || l.lead_campaign=="Website WA"  || l.lead_campaign=="Meta Chat" || l.lead_campaign=="Meta Ads WA") && !("fast_reach_attempted" in l) && !("fast_reach" in l) &&  !(newgetqualitylead(l)=="Titanium") && ("model_beta" in l && l.model_beta=="Alpha"))
        setlistleadData3(temp)

      }

      const handleleadSearch8 = async () => {
        // console.log(searchData2)
        if (searchData6.start_date && searchData6.end_date) {
          const data = await searchLeadsbyDate(
            searchData6.start_date,
            searchData6.end_date
          );
          setlistleadData4(data.data.filter(l=>  ("model_beta" in l && l.model_beta=="Alpha") && 
            ((newgetqualitylead(l)=="Iron" || newgetqualitylead(l)=="Copper" || newgetqualitylead(l)=="Silver") 
            || (newgetqualitylead(l)!=="Titanium" && (l.lead_destination=="Turkey" || l.lead_destination=="Europe" || l.lead_destination=="Odisha" || l.lead_destination=="Gujarat" || l.lead_destination=="Madhya Pradesh" || l.lead_destination=="Tamil Nadu" || l.lead_destination=="Golden Triangle" || l.lead_destination.trim()=="")) || l.lead_destination=="Others" || l.lead_destination=="All" || l.lead_destination.trim()=="")) )
          
          
    
          //console.log(data.data);
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      };

      const handleleadSearch9 = async () => {
        // console.log(searchData2)
        if (searchData6.start_date && searchData6.end_date) {
          const data = await searchLeadsbyDate(
            searchData6.start_date,
            searchData6.end_date
          );
         
          setlistleadData4(data.data.filter(l=>
            (newgetqualitylead(l)=="Iron" || newgetqualitylead(l)=="Copper" || newgetqualitylead(l)=="Silver") 
            || (newgetqualitylead(l)!=="Titanium" && (l.lead_destination=="Turkey" || l.lead_destination=="Europe" || l.lead_destination=="Odisha" || l.lead_destination=="Gujarat" || l.lead_destination=="Madhya Pradesh" || l.lead_destination=="Tamil Nadu" || l.lead_destination=="Golden Triangle" || l.lead_destination.trim()==""))
         
          )) 
          
    
          console.log(data.data);
          console.log(data.data.filter(l=>
            (newgetqualitylead(l)=="Iron" || newgetqualitylead(l)=="Copper" || newgetqualitylead(l)=="Silver") 
            || (newgetqualitylead(l)!=="Titanium" && (l.lead_destination=="Turkey" || l.lead_destination=="Europe" || l.lead_destination=="Odisha" || l.lead_destination=="Gujarat" || l.lead_destination=="Madhya Pradesh" || l.lead_destination=="Tamil Nadu" || l.lead_destination=="Golden Triangle" || l.lead_destination.trim()==""))
         
          ))
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      };

      const handleleadSearch10 = async () => {
        // console.log(searchData2)
        if (searchData5.start_date && searchData5.end_date) {
          const data = await fetchtripbycreateddate(
            searchData5.start_date,
            searchData5.end_date
          );
           //console.log(data.data);
          const temp=data.data.filter(tripdata=>"lead" in tripdata && "quality_upgrade" in tripdata.lead && tripdata.lead.quality_upgrade)
          setlisttripdata(temp)
          
          
    
         
          //console.log(temp);
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      };
     
      const handleleadSearch7 = async (startdate, enddate) => {
        // console.log(searchData2)
        if (startdate && enddate) {
          const data = await searchLeadsbyDate(
            startdate, enddate
          );
           const data4 = await fetchLeads7to90();
          //console.log(data.data)
          //console.log(data4.data)
          var finalset=data.data.filter(l=>
            ((newgetqualitylead(l)=="Iron" || newgetqualitylead(l)=="Copper" || newgetqualitylead(l)=="Silver") 
           || (!("lead_destination" in l)) || 
           (newgetqualitylead(l)!=="Titanium" && ("lead_destination" in l && (l.lead_destination=="Turkey" || l.lead_destination=="Europe" || l.lead_destination=="Odisha" || l.lead_destination=="Gujarat" || l.lead_destination=="Madhya Pradesh" || l.lead_destination=="Tamil Nadu" || l.lead_destination=="Golden Triangle" || l.lead_destination=="" || l.lead_destination.length==1)))) && !("fast_reach_attempted" in l && l.fast_reach_attempted) && !("model_beta" in l && l.model_beta=="Beta"))
          // console.log(finalset)
          //setlistleadData4(temp50)  
          const temp50=[...finalset,...data4.data]
            // const temp5=data.data.filter(l=>l.lead_id==180105)
            //console.log(temp50)
            // console.log(getquality(temp5[0].lead_status,temp5[0].time_to_book, temp5[0].lead_platform, temp5[0].lead_travel_date, temp5[0].quality_upgrade, temp5[0].lead_passport))
          
          let temp=[]
          for(let i=0; i<temp50.length; i++){
            temp=[...temp, temp50[i].mobile_number]
          }
          //console.log(temp)
          const data2=await fetchdupTripsbyNumber(temp)
          setdupData(data2.data)
           var temp2=[]
    for(let i=0;i<temp50.length;i++){
    const x=data2.data.filter(t=> t.primary_mobile_number ==temp50[i].mobile_number)
    if(x && x.length > 0 && x[0].trip_status=="Active"){
    //console.log(temp50[i])
  
    }else{
    temp2=[...temp2, temp50[i]]
    }
    }
    console.log(temp2.length)
  setlistleadData4(temp2) 

          //console.log(data2.data)
          //console.log(data.data);
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      };

        const handleleadSearch11=async () => {
        const data = await searchLeadsbyDate(
          DateCalc(-2),
          DateCalc(1)
        );
        var temp2=data.data.filter(l=>!(newgetqualitylead(l)=="Iron" || newgetqualitylead(l)=="Copper" || newgetqualitylead(l)=="Silver"))
        var temp=temp2.filter(l=>l.manual_fast_reach_attempted && !("manual_fast_reach" in l && l.manual_fast_reach) && !("manual_fast_reach_failed" in l && l.manual_fast_reach_failed) && (l.lead_owner=="Abhishek" || l.lead_owner=="RohitS" || l.lead_owner=="Asgar") && !("work_complete" in l && l.work_complete) && ("model_beta" in l && l.model_beta=="Alpha"))
        setlistleadData5(temp)

      }

      const handleleadSearch12 = async () => {
        // console.log(searchData2)
        if (searchData5.start_date && searchData5.end_date) {
          const data = await fetchtripbycreateddate(
            searchData5.start_date,
            searchData5.end_date
          );
           console.log(data.data);
          const temp=data.data.filter(tripdata=>"lead" in tripdata && "manual_fr" in tripdata.lead && tripdata.lead.manual_fr)
          setlisttripdata(temp)
          
          
    
         
          //console.log(temp);
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      };

      const handleleadSearch18 = async () => {
        // console.log(searchData2)
        if (searchData6.start_date && searchData6.end_date) {
          const data = await searchLeadsbyDate(
            searchData6.start_date,
            searchData6.end_date
          );
         var temp=data.data.filter(l=>(l.model_beta=="Beta-Initial" || l.model_beta=="Beta") && l.cust_create)
          setlistleadData18(temp)
         
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      };

      const getdupnumber=(number)=>{
        const x=dupData.filter(t=> t.primary_mobile_number ==number)
        if(x && x.length > 0){
        //console.log(x)
        return x[0].trip_id+" ("+x[0].trip_owner+" - "+x[0].trip_status+")"
        }else{
          return ""
        }
      }

      const getPostponed=async()=>{
        //console.log("Here")
       
        const data=await getallPostponedtrips()
        console.log(data.data)
        
        setpostponedtrips(data.data)
       
        
      }
      var temp=[...postponedtrips]
      //console.log(temp)
      if(temp.length>0 && !showallpostponed){
          temp=temp.filter(temp2=>("status_history" in temp2 && temp2.status_history.length>0?
            (new Date(DateCalc(0)).getTime()+1000*60*60*5)>new Date(temp2.updatedAt).getTime() && new Date(temp2.follow_up[temp2.follow_up.length-1].date).getTime()<new Date().getTime() && new Date(temp2.status_history[temp2.status_history.length-1].date).getTime()<new Date(DateCalc(-15)).getTime():""))
          console.log(temp)
          //setpostponedtrips(temp)
        }
      var leadlist=[...listleadData3]
      if(listleadData3.length>0){
        
        //console.log(leadlist)
        if("destination" in leadfilterData2 && leadfilterData2.destination!==""){
          leadlist=leadlist.filter(l=>l.lead_destination==leadfilterData2.destination)
        }
        //console.log(leadlist)
        if("wd" in leadfilterData2 && leadfilterData2.wd !==""){
          leadlist=leadlist.filter(l=>l.work_complete==leadfilterData2.wd)
        }else if(leadfilterData2.wd ==""){
        }else{
            leadlist=leadlist.filter(l=>!l.work_complete)  
        }
        if("qu" in leadfilterData2 && leadfilterData2.qu !==""){
            leadlist=leadlist.filter(l=>l.quality_upgrade==leadfilterData2.qu)  
        }
        if("sp" in leadfilterData2 && leadfilterData2.sp !==""){
          leadlist=leadlist.filter(l=>l.lead_owner_support==leadfilterData2.sp)  
      }
      if("fastreach" in leadfilterData2 && leadfilterData2.fastreach !==""){
        leadlist=leadlist.filter(l=>l.fast_reach)  
    }
      }
      var leadlist2=[...listleadData4]
      if(listleadData4.length>0){
        
        //console.log(leadlist2)
        if("destination" in leadfilterData && leadfilterData.destination!==""){
          leadlist2=leadlist2.filter(l=>l.lead_destination==leadfilterData.destination)
        }
        //console.log(leadlist2)
        if("wd" in leadfilterData && leadfilterData.wd !==""){
          leadlist2=leadlist2.filter(l=>l.work_complete==leadfilterData.wd)
        }else if(leadfilterData.wd ==""){
        }else{
            leadlist2=leadlist2.filter(l=>!l.work_complete)  
        }
        if("qu" in leadfilterData && leadfilterData.qu !==""){
            leadlist2=leadlist2.filter(l=>l.quality_upgrade==leadfilterData.qu)  
        }
        if("sp" in leadfilterData && leadfilterData.sp !==""){
          leadlist2=leadlist2.filter(l=>l.lead_owner_support==leadfilterData.sp)  
      }
      
      }
      var analytics10 = [...calldataleads2];
      if(calldataleads2.length > 0) {
       
        
        if(searchData4.support_owner){
          analytics10=analytics10.filter(cr=>cr.callrecord.answered_agent_name==searchData4.support_owner)
        }
        if(searchData4.fast_reach){
          analytics10=analytics10.filter(cr=>cr.fast_reach)
        }
        if(searchData4.only_ss){
          analytics10=analytics10.filter(cr=>sslist.includes(cr.callrecord.answered_agent_name))
        }
        if(searchData4.hangup_cause){
          analytics10=analytics10.filter(cr=>cr.callrecord.hangup_cause==searchData4.hangup_cause)
        }
      }
      //console.log(analytics10) 
      //console.log(leadlist)
      const leaddatalistdisplay2 = leadlist2.map((data) => ({
        lead_id: data.lead_id,
        id: leadlist2.indexOf(data),
        lead_name: data.lead_name,
        phone:data.mobile_number,
        lead_status: newgetqualitylead(data),
        lead_destination: data.lead_destination,
        lead_travel_date:data.lead_travel_date,
        lead_createdAt: new Date(data.createdAt).toLocaleString(),
        lead_canc:data.canc_reason,
        work_done_time: data.work_complete?new Date(data.work_complete_date).toLocaleString():"",
        time_to_action:((new Date(data.assignedAt).getTime()-new Date(data.createdAt).getTime())/(1000*60*60)).toFixed(2),
        only_wa:data.only_whatsapp,
        dup_number:dupData && dupData.length>0 && "mobile_number" in data?getdupnumber(data.mobile_number):"",
        attempt1:"callrecord" in data && data.callrecord.length>0?data.callrecord[0].answered_agent_name+ " - " +data.callrecord[0].start_stamp + "("+data.callrecord[0].duration +")":"",
        attempt2:"callrecord" in data && data.callrecord.length>1?data.callrecord[1].answered_agent_name+ " - " +data.callrecord[1].start_stamp + "("+data.callrecord[1].duration +")":"",
        attempt3:"callrecord" in data && data.callrecord.length>2?data.callrecord[2].answered_agent_name+ " - " +data.callrecord[2].start_stamp + "("+data.callrecord[2].duration +")":"",
        support:data.lead_owner_support,
        notes:data.lead_cust_notes,
        potential:data.potential,
        upgrade:data.quality_upgrade,
      }));

      const leaddatalistdisplay = leadlist.map((data) => ({
        lead_id: data.lead_id,
        id: leadlist.indexOf(data),
        lead_name: "lead_platform" in data && data.lead_paltform=="TripCrafetrs"?data.lead_name+" (TC)":data.lead_name,
        phone:data.mobile_number,
        lead_status: newgetqualitylead(data),
        lead_destination: data.lead_destination,
        model:data.model_beta,
        time_to_action:((new Date().getTime()-new Date(data.createdAt).getTime())/(1000*60*60)).toFixed(2),
        only_wa:data.only_whatsapp,
        dup_number:dupData && dupData.length>0 && "mobile_number" in data?getdupnumber(data.mobile_number):"",
        attempt1:"callrecord" in data && data.callrecord.length>0?data.callrecord[0].start_stamp + "("+data.callrecord[0].duration +")":"",
        attempt2:"callrecord" in data && data.callrecord.length>1?data.callrecord[1].start_stamp + "("+data.callrecord[1].duration +")":"",
        attempt3:"callrecord" in data && data.callrecord.length>2?data.callrecord[2].start_stamp + "("+data.callrecord[2].duration +")":"",
        support:data.lead_owner_support,
      }));

      const leaddatalistdisplay5 = listleadData5.map((data) => ({
        lead_id: data.lead_id,
        id: listleadData5.indexOf(data),
        lead_name: "lead_platform" in data && data.lead_paltform=="TripCrafetrs"?data.lead_name+" (TC)":data.lead_name,
        lead_owner:data.lead_owner,
        fr_wa:data.fast_reach_whatsapp,
        phone:data.mobile_number,
        lead_status: newgetqualitylead(data),
        lead_destination: data.lead_destination,
        attempt1:"callrecord" in data && data.callrecord.length>0?data.callrecord[0].start_stamp + "("+data.callrecord[0].duration +")":"",
        attempt2:"callrecord" in data && data.callrecord.length>1?data.callrecord[1].start_stamp + "("+data.callrecord[1].duration +")":"",
        attempt3:"callrecord" in data && data.callrecord.length>2?data.callrecord[2].start_stamp + "("+data.callrecord[2].duration +")":"",
      }));

      var l18=[...listleadData18]
      if(leadfilterData.model){
        l18=l18.filter(l=>l.model_beta==leadfilterData.model)
      }

        const leaddatalistdisplay18 = l18.map((data) => ({
        lead_id: data.lead_id,
        id: l18.indexOf(data),
        lead_name: "lead_platform" in data && data.lead_paltform=="TripCrafetrs"?data.lead_name+" (TC)":data.lead_name,
        work_complete:data.work_complete,
        lead_status: newgetqualitylead(data),
        lead_createdAt:data.createdAt,
        lead_destination: data.lead_destination,
        lead_travel_date:data.lead_travel_date,
        attempt1:"callrecord" in data && data.callrecord.length>0?data.callrecord[0].start_stamp + "("+data.callrecord[0].duration +")":"",
        attempt2:"callrecord" in data && data.callrecord.length>1?data.callrecord[1].start_stamp + "("+data.callrecord[1].duration +")":"",
        attempt3:"callrecord" in data && data.callrecord.length>2?data.callrecord[2].start_stamp + "("+data.callrecord[2].duration +")":"",
        attempt4:"callrecord" in data && data.callrecord.length>3?data.callrecord[3].start_stamp + "("+data.callrecord[3].duration +")":"",
      }));

      const tripdatalistdisplay = temp.map((data) => ({
        trip_id: data.trip_id,
        id: postponedtrips.indexOf(data),
        trip_owner: data.trip_owner,
        cust_name:data.cust_name,
        dest:data.primary_destination,
        trip_status:data.trip_status,
        postponedAt:"status_history" in data && data.status_history.length>0?data.status_history[data.status_history.length-1].date:"",
        last_fup:"follow_up" in data && data.follow_up.length>0?data.follow_up[data.follow_up.length-1].createdAt:""
      }));

      const tripdatalistdisplay2=listtripdata.map(data=>({
        trip_id: data.trip_id,
        id: listtripdata.indexOf(data),
        trip_owner: data.trip_owner,
        dest:data.primary_destination,
        trip_status:data.trip_status,
        cust_name:data.cust_name,
        lead_id:"lead" in data?data.lead.lead_id:"",
        initial_quality: "lead" in data?data.lead.initial_quality:"",
      })
      )
      analytics10=removeDuplicatesmulti(analytics10, "callrecord", "answered_agent_name", "start_stamp", "duration")
      const analyticsdatalistdisplay10 = analytics10.map((dailydata) => ({
          agent_name:dailydata.callrecord.answered_agent_name,
          id: analytics10.indexOf(dailydata),
          talk_time: parseInt(dailydata.callrecord.outbound_sec),
          effective: parseInt(dailydata.callrecord.outbound_sec)>120?true:false,
          disconnected_by:dailydata.callrecord.hangup_cause,
          call_to_number:dailydata.callrecord.call_to_number,
          call_from_number:dailydata.callrecord.caller_id_number,
          record:dailydata.callrecord.recording_url,
          object_type:dailydata.object_type,
          createdAt:dailydata.createdAt,
          fr_wa:dailydata.fr_wa,
          object_id:dailydata.object_id,
          call_start:dailydata.callrecord.start_stamp,
          uuid: dailydata.callrecord.uuid,
          call_id: dailydata.callrecord.call_id,
          call_connected: dailydata.callrecord.call_connected,
          gap:Math.round((new Date(dailydata.callrecord.start_stamp).getTime()-new Date(dailydata.createdAt).getTime())/(1000*60)),
        }));

      const formatTime = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
        const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
        const seconds = (totalSeconds % 60).toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
      };

      const leadcheck=async()=>{
        try{
          const data = await fetchRules();
          //console.log(data.data)
          const data2=await todaysignin()
          //console.log(data2.data)
          var emaillist=data2.data.map(d=>d.user)
          var saleslist=employeelist.filter(e=>e.role=="Sales" && emaillist.includes(e.email))
          var salesusers=saleslist.map(s=>s.short_name)
          console.log(salesusers)
          const availablesp=data.data[0].leadrule.filter(lr=>salesusers.includes(lr.name) && lr.availability=="Yes")
          console.log(availablesp)
          setsplist(availablesp)
          var saleslist2=employeelist.filter(e=>e.role=="Sales" && !emaillist.includes(e.email))
          var salesusers2=saleslist2.map(s=>s.short_name)
          const availablesp2=data.data[0].leadrule.filter(lr=>salesusers2.includes(lr.name) && lr.availability=="No")
          console.log(availablesp2)
          setsplist2(availablesp2)
          setopen(true)
        }catch(e){
          console.log(e)
        }
      }

      const handleClose=()=>{
        setopen(false)
      }

      // const changechatstate=(data)=>{
      //   console.log("123")
      //   console.log(data)
      //   if(role=="Admin"){
      //     console.log(data)
      //   }
      // }

      // socket.on(`newLead`, changechatstate)

      return(<div>
      <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Fast Reach
        </Typography>
        <Typography variant="h6" align="center" className={classes.headertext}>Time since page load: {formatTime(secondsPassed)}</Typography>
        <div align="center">
         
          <Button
            onClick={handleleadSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Load
          </Button>
       <Button
            onClick={leadcheck}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Lead Report
          </Button>
        
        </div>
        
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Destination">Destination</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Destination"
            // value={leadfilterData.destination}
            onChange={(e) =>
              setleadfilterData2({
                ...leadfilterData2,
                destination: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Bali"}>Bali</MenuItem>
            <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
            {dest.map((dest) => {
              return <MenuItem value={dest}>{dest}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="wd">Work Done</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="wd"
            // value={leadfilterData.wd}
            onChange={(e) =>
              setleadfilterData2({
                ...leadfilterData2,
                wd: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="qu">Quality Upgrade</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="qu"
            // value={leadfilterData.qu}
            onChange={(e) =>
              setleadfilterData2({
                ...leadfilterData2,
                qu: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="sp">Support Person</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="sp"
            // value={leadfilterData.sp}
            onChange={(e) =>
              setleadfilterData2({
                ...leadfilterData2,
                sp: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Amit"}>Amit</MenuItem>
            {emp.map((emp) => {
              return <MenuItem value={emp}>{emp}</MenuItem>;
            })}
            
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="fastreach">Fast Reach</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="fastreach"
            // value={leadfilterData.qu}
            onChange={(e) =>
              setleadfilterData2({
                ...leadfilterData2,
                fastreach: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl>

        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={lcolumns}
            autoPageSize
         
          ></DataGrid>
        </div>
      </Paper>
         <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          LQ Lead List
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData6({ ...searchData6, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData6({ ...searchData6, end_date: e.target.value })
            }
          />
          <Button
            onClick={handleleadSearch8}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          {role=="Admin" || role=="TL" || role=="Manager"?(  <Button
            onClick={handleleadSearch9}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search All
          </Button>):("")}
          {/* {role=="Admin" && leaddatalistdisplay2.length>1?(<div>
                   <CSVLink data={leaddatalistdisplay2} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")} */}
        </div>
        
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Destination">Destination</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Destination"
            // value={leadfilterData.destination}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                destination: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Bali"}>Bali</MenuItem>
            <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
            {dest.map((dest) => {
              return <MenuItem value={dest}>{dest}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="wd">Work Done</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="wd"
            // value={leadfilterData.wd}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                wd: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="qu">Quality Upgrade</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="qu"
            // value={leadfilterData.qu}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                qu: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="sp">Support Person</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="sp"
            // value={leadfilterData.sp}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                sp: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Amit"}>Amit</MenuItem>
            {emp.map((emp) => {
              return <MenuItem value={emp}>{emp}</MenuItem>;
            })}
            
          </Select>
        </FormControl>

        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay2}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={lcolumns2}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
        </div>
      </Paper>
      <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Postponed Trips
        </Typography>
        <div align="center">
         <Button
            onClick={() => {
              getPostponed();
              
              }}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Load
          </Button>
         <Button
            onClick={() => {
             
              setshowallpostponed(!showallpostponed);
              }}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            {showallpostponed?"Show TBD":"Show All"}
          </Button>
          </div>
        <div style={{ height: 2000, width: "100%" }}>
        <DataGrid
            rows={tripdatalistdisplay}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={tcolumns}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
             </div>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          FR Re-Attempt
        </Typography>
        <div align="center">
          
          <Button
            onClick={handleleadSearch11}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Load
          </Button>
        </div>

        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay5}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={lcolumns5}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
        </div>
      </Paper>
          <Dialog fullWidth maxWidth="xl" open={open} onClose={handleClose}>
            <Table>
              
              {splist.length>0 && splist.map(data=>
              <div>
              <TableRow>
                <TableCell>{data.name+" - "+getempTL(data.name, employeelist)+" - "+getmanager(getempTL(data.name, employeelist), new Date())}</TableCell>
              {data.new_destinations.map(d=>
              
                <TableCell>{d.dest +"-"+ d.capacity_used+"/"+d.capacity}</TableCell>
               
              
              )}
              <TableCell>{"Total -"+getSumByKey(data.new_destinations,"capacity_used")}</TableCell>
              </TableRow>
              </div>
              )}
            </Table>
            <br></br>
         
            <Typography variant="h4" align="center" className={classes.headertext}>Absent List</Typography>
        
            <br></br>
            <Table>
           
              {splist2.map(data=>
              <div>
              <TableRow>
                <TableCell>{data.name}</TableCell>
             
              </TableRow>
              </div>
              )}
            </Table>

          </Dialog>
       {role=="Admin" || role=="TL" || role=="Manager" || role=="Sales Support"?(
        <Paper variant="outlined" className={classes.paper} elevation={10}>
                      <Typography
                        variant="h4"
                        align="center"
                        className={classes.headertext}
                      >
                        {" "}
                        Call record details
                      </Typography>
                    
                      <div align="center">
                        <TextField
                          variant="outlined"
                          type="date"
                          label="Call On or after"
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setsearchData4({
                              ...searchData4,
                              start_date: e.target.value,
                            })
                          }
                        />
        
                        <TextField
                          variant="outlined"
                          type="date"
                          label="Call On or before"
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setsearchData4({ ...searchData4, end_date: e.target.value })
                          }
                        />
        
                        <Button
                          onClick={handlecallSearch2}
                          color="secondary"
                          variant="contained"
                          className={classes.button}
                        >
                          Search
                        </Button>
                    
                          <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="owner">Support Owner</InputLabel>
                    <Select
                      displayEmpty
                      InputLabelProps={{ shrink: true }}
                      className={classes.textField}
                      labelId="owner"
                      value={searchData4.support_owner}
                      onChange={(e) =>
                        setsearchData4({ ...searchData4, support_owner: e.target.value })
                      }
                    >
                    <MenuItem value={""}>Clear</MenuItem>
                     {emp.map((emp) => {
                        return <MenuItem value={emp}>{emp}</MenuItem>;
                      })}
                     
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="owner">Only SS</InputLabel>
                    <Select
                      displayEmpty
                      InputLabelProps={{ shrink: true }}
                      className={classes.textField}
                      labelId="owner"
                      value={searchData4.only_ss}
                      onChange={(e) =>
                        setsearchData4({ ...searchData4, only_ss: e.target.value })
                      }
                    >
                    <MenuItem value={""}>Clear</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                     
                     
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="owner">Fast Reach</InputLabel>
                    <Select
                      displayEmpty
                      InputLabelProps={{ shrink: true }}
                      className={classes.textField}
                      labelId="owner"
                      value={searchData4.fast_reach}
                      onChange={(e) =>
                        setsearchData4({ ...searchData4, fast_reach: e.target.value })
                      }
                    >
                    <MenuItem value={""}>Clear</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                     
                     
                    </Select>
                  </FormControl>
                    <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="owner">Hang UP Cause</InputLabel>
                    <Select
                      displayEmpty
                      InputLabelProps={{ shrink: true }}
                      className={classes.textField}
                      labelId="owner"
                      value={searchData4.hangup_cause}
                      onChange={(e) =>
                        setsearchData4({ ...searchData4, hangup_cause: e.target.value })
                      }
                    >
                    <MenuItem value={""}>Clear</MenuItem>
                    <MenuItem value={"busy"}>busy</MenuItem>
                    <MenuItem value={"c2c_channel_limit_utilized"}>c2c_channel_limit_utilized</MenuItem> 
                    <MenuItem value={"Call rejected"}>Call rejected</MenuItem>
                    <MenuItem value={"cancel"}>cancel</MenuItem>
                    <MenuItem value={"chanunavail"}>chanunavail</MenuItem> 
                    <MenuItem value={"disconnected_by_callee"}>disconnected_by_callee</MenuItem>
                    <MenuItem value={"disconnected_by_caller"}>disconnected_by_caller</MenuItem>
                    <MenuItem value={"Interworking"}>Interworking</MenuItem>
                    <MenuItem value={"Network out of order"}>Network out of order</MenuItem>
                    <MenuItem value={"No user response"}>No user response</MenuItem>
                    <MenuItem value={"noanswer"}>noanswer</MenuItem>
                    <MenuItem value={"missed"}>missed</MenuItem>
                    <MenuItem value={"Recovery on time expire"}>Recovery on time expire</MenuItem>
                    <MenuItem value={"Requested channel unavailable"}>Requested channel unavailable</MenuItem>
                    <MenuItem value={"User busy"}>User busy</MenuItem>
                    
                    </Select>
                  </FormControl>   
                        
                      </div>
                       {analyticsdatalistdisplay10.length>1?(<div>
                                          <CSVLink data={analyticsdatalistdisplay10} headers={headers10}>Download CSV</CSVLink>
                                          </div>
                                       ):("")}
                      {analyticsdatalistdisplay10.length > 0 ? (
                        <div style={{ height: 800, width: "100%" }}>
                          <DataGrid
                            rows={analyticsdatalistdisplay10}
                            columns={columns10}
                            autoPageSize
                            onCellDoubleClick={(getValue) =>
                      gridcellclicklead(getValue.row.lead_id)
                    }
                          ></DataGrid>
                        </div>
                      ) : (
                        <div align="center">
                          <h1>No data found</h1>
                        </div>
                      )}
                    </Paper>
       ):("")}
          
                      
                   
  <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Titanium/FR Leads
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData5({ ...searchData5, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData5({ ...searchData5, end_date: e.target.value })
            }
          />
          <Button
            onClick={handleleadSearch10}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Titanium Search
          </Button>
              <Button
            onClick={handleleadSearch12}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            FR Search
          </Button>
        
        </div>
        

        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={tripdatalistdisplay2}
            onCellDoubleClick={(getValue) =>
              gridcellclick(getValue.row.trip_id)
            }
            columns={tcolumns2}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
        </div>
      </Paper>
      {cuser && (cuser=="JatinSejwal" || cuser=="Debayan"||cuser=="Abhishek")?(
      <Paper variant="outlined" className={classes.paper}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Model Beta
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData6({ ...searchData6, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Lead Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData6({ ...searchData6, end_date: e.target.value })
            }
          />
          <Button
            onClick={handleleadSearch18}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
         
          {/* {role=="Admin" && leaddatalistdisplay2.length>1?(<div>
                   <CSVLink data={leaddatalistdisplay2} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")} */}
        </div>
        
        {/* <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Destination">Destination</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="Destination"
            // value={leadfilterData.destination}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                destination: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Bali"}>Bali</MenuItem>
            <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
            {dest.map((dest) => {
              return <MenuItem value={dest}>{dest}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="wd">Work Done</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="wd"
            // value={leadfilterData.wd}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                wd: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl>
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="qu">Quality Upgrade</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="qu"
            // value={leadfilterData.qu}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                qu: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
            
          </Select>
        </FormControl> */}
        <FormControl
          style={{
            minWidth: 240,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="sp">Model</InputLabel>
          <Select
            displayEmpty
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            labelId="sp"
            // value={leadfilterData.model}
            onChange={(e) =>
              setleadfilterData({
                ...leadfilterData,
                model: e.target.value,
              })
            }
          >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Alpha"}>Alpha</MenuItem>
           <MenuItem value={"Beta-Initial"}>Beta-Initial</MenuItem>
            <MenuItem value={"Beta"}>Beta</MenuItem>
          </Select>
        </FormControl>

        <div style={{ height: 2000, width: "100%" }}>
          <DataGrid
            rows={leaddatalistdisplay18}
            onCellDoubleClick={(getValue) =>
              gridcellclicklead(getValue.row.lead_id)
            }
            columns={lcolumns18}
            autoPageSize
            // pageSize={25}
            // autoHeight
          ></DataGrid>
        </div>
      </Paper>
      ):("")}
 
                   
    
      </div>)

    }

    export default Salessupport;